// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!../../../styles/diabetes.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * == BSD2 LICENSE ==
 * Copyright (c) 2017, Tidepool Project
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the associated License, which is identical to the BSD 2-Clause
 * License as published by the Open Source Initiative at opensource.org.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the License for more details.
 *
 * You should have received a copy of the License along with this program; if
 * not, you can obtain one from Tidepool Project at tidepool.org.
 * == BSD2 LICENSE ==
 */

.SMBGMeanAnimated--thickStroke--hpFyL {
  stroke-width: 2;
}

.SMBGMeanAnimated--smbgMean--pCLq8 {
  stroke: white;
  pointer-events: all;
}

.SMBGMeanAnimated--transparent--nsQ2r {
  fill: transparent;
}

@keyframes SMBGMeanAnimated--fadein--HFf9t {
  from {
    fill-opacity: 0.0;
  }
  to {
    fill-opacity: 1.0;
  }
}

@keyframes SMBGMeanAnimated--fadeout--CxTPF {
  from {
    fill-opacity: 1.0;
  }
  to {
    fill-opacity: 0.0;
  }
}

.SMBGMeanAnimated--fadeinAnimation--YRVli {
  animation: SMBGMeanAnimated--fadein--HFf9t 0.25s forwards ease-in-out;
}

.SMBGMeanAnimated--fadeoutAnimation--uVaMB {
  animation: SMBGMeanAnimated--fadeout--CxTPF 0.25s forwards ease-in-out;
}

.SMBGMeanAnimated--veryLowFadeIn--n4bcc {
}

.SMBGMeanAnimated--veryLowFadeOut--r5r8y {
}

.SMBGMeanAnimated--lowFadeIn--hQySO {
}

.SMBGMeanAnimated--lowFadeOut--LHWzI {
}

.SMBGMeanAnimated--targetFadeIn--pkKxu {
}

.SMBGMeanAnimated--targetFadeOut--jpIBS {
}

.SMBGMeanAnimated--highFadeIn--zLVe7 {
}

.SMBGMeanAnimated--highFadeOut--uW0ar {
}

.SMBGMeanAnimated--veryHighFadeIn--PIqyX {
}

.SMBGMeanAnimated--veryHighFadeOut--GHnzD {
}
`, "",{"version":3,"sources":["webpack://./src/components/trends/smbg/SMBGMeanAnimated.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;EAeE;;AAMF;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EAEb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,qEAA4C;AAC9C;;AAEA;EACE,sEAA6C;AAC/C;;AAEA;AAGA;;AAEA;AAGA;;AAEA;AAGA;;AAEA;AAGA;;AAEA;AAGA;;AAEA;AAGA;;AAEA;AAGA;;AAEA;AAGA;;AAEA;AAGA;;AAEA;AAGA","sourcesContent":["/*\n * == BSD2 LICENSE ==\n * Copyright (c) 2017, Tidepool Project\n *\n * This program is free software; you can redistribute it and/or modify it under\n * the terms of the associated License, which is identical to the BSD 2-Clause\n * License as published by the Open Source Initiative at opensource.org.\n *\n * This program is distributed in the hope that it will be useful, but WITHOUT\n * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS\n * FOR A PARTICULAR PURPOSE. See the License for more details.\n *\n * You should have received a copy of the License along with this program; if\n * not, you can obtain one from Tidepool Project at tidepool.org.\n * == BSD2 LICENSE ==\n */\n\n:export {\n  stroke: 2;\n}\n\n.thickStroke {\n  stroke-width: 2;\n}\n\n.smbgMean {\n  stroke: white;\n  composes: thickStroke;\n  pointer-events: all;\n}\n\n.transparent {\n  fill: transparent;\n}\n\n@keyframes fadein {\n  from {\n    fill-opacity: 0.0;\n  }\n  to {\n    fill-opacity: 1.0;\n  }\n}\n\n@keyframes fadeout {\n  from {\n    fill-opacity: 1.0;\n  }\n  to {\n    fill-opacity: 0.0;\n  }\n}\n\n.fadeinAnimation {\n  animation: fadein 0.25s forwards ease-in-out;\n}\n\n.fadeoutAnimation {\n  animation: fadeout 0.25s forwards ease-in-out;\n}\n\n.veryLowFadeIn {\n  composes: bgVeryLow from '../../../styles/diabetes.css';\n  composes: fadeinAnimation;\n}\n\n.veryLowFadeOut {\n  composes: bgVeryLow from '../../../styles/diabetes.css';\n  composes: fadeoutAnimation;\n}\n\n.lowFadeIn {\n  composes: bgLow from '../../../styles/diabetes.css';\n  composes: fadeinAnimation;\n}\n\n.lowFadeOut {\n  composes: bgLow from '../../../styles/diabetes.css';\n  composes: fadeoutAnimation;\n}\n\n.targetFadeIn {\n  composes: bgTarget from '../../../styles/diabetes.css';\n  composes: fadeinAnimation;\n}\n\n.targetFadeOut {\n  composes: bgTarget from '../../../styles/diabetes.css';\n  composes: fadeoutAnimation;\n}\n\n.highFadeIn {\n  composes: bgHigh from '../../../styles/diabetes.css';\n  composes: fadeinAnimation;\n}\n\n.highFadeOut {\n  composes: bgHigh from '../../../styles/diabetes.css';\n  composes: fadeoutAnimation;\n}\n\n.veryHighFadeIn {\n  composes: bgVeryHigh from '../../../styles/diabetes.css';\n  composes: fadeinAnimation;\n}\n\n.veryHighFadeOut {\n  composes: bgVeryHigh from '../../../styles/diabetes.css';\n  composes: fadeoutAnimation;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stroke": `2`,
	"thickStroke": `SMBGMeanAnimated--thickStroke--hpFyL`,
	"smbgMean": `SMBGMeanAnimated--smbgMean--pCLq8 SMBGMeanAnimated--thickStroke--hpFyL`,
	"transparent": `SMBGMeanAnimated--transparent--nsQ2r`,
	"fadeinAnimation": `SMBGMeanAnimated--fadeinAnimation--YRVli`,
	"fadein": `SMBGMeanAnimated--fadein--HFf9t`,
	"fadeoutAnimation": `SMBGMeanAnimated--fadeoutAnimation--uVaMB`,
	"fadeout": `SMBGMeanAnimated--fadeout--CxTPF`,
	"veryLowFadeIn": `SMBGMeanAnimated--veryLowFadeIn--n4bcc ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bgVeryLow"]} SMBGMeanAnimated--fadeinAnimation--YRVli`,
	"veryLowFadeOut": `SMBGMeanAnimated--veryLowFadeOut--r5r8y ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bgVeryLow"]} SMBGMeanAnimated--fadeoutAnimation--uVaMB`,
	"lowFadeIn": `SMBGMeanAnimated--lowFadeIn--hQySO ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bgLow"]} SMBGMeanAnimated--fadeinAnimation--YRVli`,
	"lowFadeOut": `SMBGMeanAnimated--lowFadeOut--LHWzI ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bgLow"]} SMBGMeanAnimated--fadeoutAnimation--uVaMB`,
	"targetFadeIn": `SMBGMeanAnimated--targetFadeIn--pkKxu ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bgTarget"]} SMBGMeanAnimated--fadeinAnimation--YRVli`,
	"targetFadeOut": `SMBGMeanAnimated--targetFadeOut--jpIBS ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bgTarget"]} SMBGMeanAnimated--fadeoutAnimation--uVaMB`,
	"highFadeIn": `SMBGMeanAnimated--highFadeIn--zLVe7 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bgHigh"]} SMBGMeanAnimated--fadeinAnimation--YRVli`,
	"highFadeOut": `SMBGMeanAnimated--highFadeOut--uW0ar ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bgHigh"]} SMBGMeanAnimated--fadeoutAnimation--uVaMB`,
	"veryHighFadeIn": `SMBGMeanAnimated--veryHighFadeIn--PIqyX ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bgVeryHigh"]} SMBGMeanAnimated--fadeinAnimation--YRVli`,
	"veryHighFadeOut": `SMBGMeanAnimated--veryHighFadeOut--GHnzD ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bgVeryHigh"]} SMBGMeanAnimated--fadeoutAnimation--uVaMB`
};
export default ___CSS_LOADER_EXPORT___;
